import request from './request'

/**
 * 註冊（邀請制）—— 信箱 + 密碼 + 邀請碼，邀請碼**必填**。
 * 註冊成功直接回 token，等於註冊完就登入，不用再登一次。
 * captcha 走 query（JFinal validateCaptcha 讀 query + cookie），其餘走 body。
 */
export function register(payload) {
  const body = {
    email: payload.email,
    password: payload.password,
    nickname: payload.nickname,
    invite_code: payload.invite_code
  }
  return request.post('/auth/register', body, { params: { captcha: payload.captcha } })
}

/** 登录 {username, password, captcha} → {token, id, username, nickname, role}
 *  username/password 走 body（避免 URL 泄露）；captcha 走 query（供 JFinal validateCaptcha） */
export function login(payload) {
  const body = { username: payload.username, password: payload.password }
  return request.post('/auth/login', body, { params: { captcha: payload.captcha } })
}

/** 登出 */
export function logout() {
  return request.post('/auth/logout')
}

/** 当前登录用户 */
export function fetchMe() {
  return request.get('/auth/me')
}
